/** @module @category Extension */ import { getExtensionStore } from "@openmrs/esm-extensions";
import { createUseStore } from "./useStore.js";
export const useExtensionStore = createUseStore(getExtensionStore());
